/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_Media_PlayerInputs */



/**
* | output |
* | --- |
* | "Media Player" |
*
* @param {Shortcut_Keys_Group_Media_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_media_player = /** @type {((inputs?: Shortcut_Keys_Group_Media_PlayerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_Media_PlayerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecteur media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienplayer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lettore multimediale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Медиаплеер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reproductor multimedia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体播放器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアプレーヤー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया प्लेयर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reprodutor de mídia")
	return /** @type {LocalizedString} */ ("Media Player")
});